import React, { useState, useEffect } from 'react';
import './CompliancePanel.css';

const CompliancePanel = ({ onVolver }) => {
  const [logs, setLogs] = useState([]);
  const [status, setStatus] = useState('Conforme');
  const [notes, setNotes] = useState('');
  const [error, setError] = useState('');

  const fetchLogs = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch('https://api.interventorsisgafr.com/api/compliance', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      setLogs(data);
    } catch (err) {
      console.error("Error al cargar registros:", err);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const token = localStorage.getItem('token');
    const verification_date = new Date().toISOString().slice(0, 10); // Fecha de hoy

    try {
      const response = await fetch('https://api.interventorsisgafr.com/api/compliance', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ verification_date, status, notes })
      });
      const newLog = await response.json();
      if (!response.ok) throw new Error(newLog.msg || 'Error al guardar el registro');
      
      fetchLogs(); // Recargar la lista de registros
      setNotes('');
      setStatus('Conforme');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="compliance-container">
      <button onClick={onVolver} className="volver-btn">&lt; Volver</button>
      <h2>Registro de Verificación Web</h2>
      <div className="compliance-content">
        {/* Formulario para nuevo registro */}
        <form onSubmit={handleSubmit} className="compliance-form">
          <h3>Nuevo Registro de Verificación</h3>
          {error && <p className="error-message">{error}</p>}
          <div className="form-group">
            <label>Estado de la Verificación</label>
            <select value={status} onChange={e => setStatus(e.target.value)}>
              <option value="Conforme">Conforme</option>
              <option value="No Conforme">No Conforme</option>
              <option value="Con Observaciones">Con Observaciones</option>
            </select>
          </div>
          <div className="form-group">
            <label>Notas / Observaciones</label>
            <textarea rows="5" value={notes} onChange={e => setNotes(e.target.value)} placeholder="Añade detalles de la verificación..."></textarea>
          </div>
          <button type="submit">Guardar Registro</button>
        </form>

        {/* Historial de registros */}
        <div className="compliance-history">
          <h3>Historial de Verificaciones</h3>
          <table>
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Estado</th>
                <th>Notas</th>
                <th>Verificado por</th>
              </tr>
            </thead>
            <tbody>
              {logs.map(log => (
                <tr key={log.id}>
                  <td>{new Date(log.verification_date).toLocaleDateString()}</td>
                  <td><span className={`status ${log.status.replace(/\s+/g, '-').toLowerCase()}`}>{log.status}</span></td>
                  <td>{log.notes}</td>
                  <td>{log.verified_by}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CompliancePanel;